import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=6b8c800e&scoped=true&"
import script from "./CardComponent.vue?vue&type=script&lang=js&"
export * from "./CardComponent.vue?vue&type=script&lang=js&"
import style0 from "./CardComponent.vue?vue&type=style&index=0&id=6b8c800e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c800e",
  null
  
)

export default component.exports